<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.sex_place')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>

    <div class="sex-card">
      <van-radio-group v-model="radio">
        <div class="item" @click="chooesSex(1)">
          <div class="item-left">
            <van-icon name="man" size="24PX" color="#4A90E2" />
            <span class="item-text">{{$t("setting.man")}}</span>
          </div>
          <van-radio name="1" checked-color="#f53d87" />
        </div>
        <div class="item" @click="chooesSex(2)">
          <div class="item-left">
            <van-icon name="woman" size="24PX" color="#FF69B4" />
            <span class="item-text">{{$t("setting.female")}}</span>
          </div>
          <van-radio name="2" checked-color="#f53d87" />
        </div>
      </van-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio: "",
      userInfo: {}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    chooesSex(sex) {
      this.$http({
        method: 'post',
        data: {sex: sex},
        url: 'user_set_sex'
      }).then(res => {
        if (res.code === 200) {
          this.getUserInfo();
          this.radio = sex;
          this.$toast(res.msg);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info',
        headers: {
          lang: window.localStorage.getItem("lang").toLowerCase()
        }
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.radio = res.data.sex;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'});
    } else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
.page {
  min-height: 100VH;
  background: #f7f8fa;
}

/* 顶部导航栏 */
.nav-bar {
  background: #8600ff;
  :deep(.van-nav-bar__title) {
    color: #333;
    font-size: 18PX;
    font-weight: 600;
  }
  :deep(.van-icon) {
    color: #333;
  }
}

/* 性别选择卡片 */
.sex-card {
  background: #fff;
  border-radius: 12PX;
  margin: 15PX;
  padding: 0 15PX;
  box-shadow: 0 4PX 12PX rgba(0, 0, 0, 0.05);
}

/* 性别选项 */
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20PX 0;
  border-bottom: 1PX solid #f5f5f5;
  cursor: pointer;
}

.item:last-child {
  border-bottom: none;
}

.item-left {
  display: flex;
  align-items: center;
  gap: 12PX;
}

.item-text {
  font-size: 16PX;
  color: #333;
  font-weight: 500;
}

/* 选中状态下的文字颜色 */
.item:active {
  background: #fafafa;
}

::v-deep .van-radio__icon {
  font-size: 20PX;
}

::v-deep .van-radio__label {
  font-size: 16PX;
  color: #333;
  margin-left: 8PX;
}
</style>